module.exports = __webpack_public_path__ + "media/two_orange.5568f19f.mp3";